export type SupplyChainInfoStep = {
  title: string;
  description: string;
  frame: { light: string; dark: string };
  icon: { light: string; dark: string };
};

export const SUPPLY_CHAIN_INFO_FRAME_RATIO = 624 / 320;

export const SUPPLY_CHAIN_INFO_STEPS = [
  {
    title: 'Scroll to zoom',
    description: 'Get the big picture or dive into details with scroll to zoom over our graphs.',
    frame: { light: '/onboarding/light/step-1-frame.mp4', dark: '/onboarding/dark/step-1-frame.mp4' },
    icon: { light: '/onboarding/light/step-1-icon.mp4', dark: '/onboarding/dark/step-1-icon.mp4' },
  },
  {
    title: 'Drag to pan',
    description: 'Move around the graph with ease by dragging to pan across the data.',
    frame: { light: '/onboarding/light/step-2-frame.mp4', dark: '/onboarding/dark/step-2-frame.mp4' },
    icon: { light: '/onboarding/light/step-2-icon.mp4', dark: '/onboarding/dark/step-2-icon.mp4' },
  },
  {
    title: 'Click for detailed information',
    description: 'Click on cards to read more contextually rich information.',
    frame: { light: '/onboarding/light/step-3-frame.mp4', dark: '/onboarding/dark/step-3-frame.mp4' },
    icon: { light: '/onboarding/light/step-3-icon.mp4', dark: '/onboarding/dark/step-3-icon.mp4' },
  },
  {
    title: 'Click nodes to expand connections',
    description: 'Explore inputs, consuming activities and reference products of dataset.',
    frame: { light: '/onboarding/light/step-4-frame.mp4', dark: '/onboarding/dark/step-4-frame.mp4' },
    icon: { light: '/onboarding/light/step-4-icon.mp4', dark: '/onboarding/dark/step-4-icon.mp4' },
  },
] as const satisfies readonly SupplyChainInfoStep[];
